//import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ContextService } from '../core/context.service';
import { ConfigurationService } from '../core/configuration.service';
import { of as observableOf, throwError as observableThrowError } from 'rxjs';
@Injectable()
export class BankService {
    private baseApiUrl: string;

    constructor (private configurationService: ConfigurationService, private httpClient: HttpClient,
        private contextService:ContextService,
    ) {
        this.baseApiUrl = this.configurationService.BaseApiUrl;
    }

    getBank(): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + 'bank').pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
    getERP(): Observable<any> {
        if (this.contextService.erp.length > 0) {
          return observableOf(this.contextService.erp);
        }
    
    
        return this.httpClient.get(this.baseApiUrl + 'bank').pipe(
          map((res: any) => {
            this.contextService.setMenuItems(res.items as Array<any>);
            return this.contextService.erp;
          }),
          catchError((err: any) => observableThrowError(err.message || 'Server error')));
      }
    updateBankDetails(editedBankhDetails: any): Observable<any> {
        return this.httpClient.put(this.baseApiUrl + 'bank', editedBankhDetails).pipe(
          map((res: Response) => res),
          catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
    authorise(bankNum: number): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + 'bank/authorise', bankNum).pipe(
          map((res: Response) => res),
          catchError((err: any) => observableThrowError(err.message || 'Server error')));
      }
    getEnableDisable(id: number): Observable<any> {
    return this.httpClient.get(`${this.baseApiUrl}bank/enabledisable/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }
}
